@use '@design/design-tokens/typography/typography' as *;

.tableHeader {
  z-index: var(--z-index-header-cell);
  position: sticky;
  top: 0;
  left: 0;

  &:not(.sortable) {
    cursor: default;
  }

  &.sortable {
    cursor: pointer;
  }

  &.lastHeaderGroup {
    @include typography-v2-body-xs;
  }

  &.notLastHeaderGroup {
    border: none;
    @include typography-v2-ui-xs;
  }

  &.highlighted {
    background-color: var(--text-inverse);
  }

  &.sortable:hover {
    background-color: var(--surface-hover);
  }

  &:not(.sortable, .highlighted):hover {
    background-color: transparent;
  }

  &:not(.sortable).highlighted:hover {
    background-color: var(--text-inverse);
  }
}
